import { ICellRendererParams } from 'ag-grid-community'
import { useProjektprognosSheetContext } from '../../context/ProjektprognosSheetContext'

interface ConditionalAggCellRendererProps extends ICellRendererParams {
  innerRenderer?: (params: ICellRendererParams) => JSX.Element | string | null
}

/**
 * Cell renderer that conditionally hides aggregation values for group rows (level 0-1)
 * based on hideHeaderAggregation state
 */
const ConditionalAggCellRenderer = (
  params: ConditionalAggCellRendererProps
) => {
  const { hideHeaderAggregation } = useProjektprognosSheetContext()

  // If we should hide aggregation and this is a group row (level 0 or 1)
  if (
    hideHeaderAggregation &&
    params.node.group &&
    (params.node.level === 0 || params.node.level === 1)
  ) {
    return null
  }

  // If there is an innerRenderer, use it
  if (params.innerRenderer) {
    return params.innerRenderer(params)
  }

  // Otherwise show standard value
  return <span>{params.valueFormatted || params.value}</span>
}

export default ConditionalAggCellRenderer
